import { Dispatch, FC, HTMLProps, ReactNode, SetStateAction } from 'react';

import { StyledSearchContainer, StyledSearchContainerContent, StyledSearchWrapper } from './NavBarWrapper.styles';

interface Props extends HTMLProps<HTMLElement> {
    children: ReactNode;
    navigationBarHeight?: number;
    ref?: Dispatch<SetStateAction<HTMLElement>>;
}

export const NavBarWrapper: FC<Props> = ({ ref, children, navigationBarHeight, ...props }) => {
    return (
        <StyledSearchWrapper {...props} $navigationBarHeight={navigationBarHeight} role="search">
            <StyledSearchContainer>
                <StyledSearchContainerContent ref={ref}>{children}</StyledSearchContainerContent>
            </StyledSearchContainer>
        </StyledSearchWrapper>
    );
};
